import ShopServiceModel  from '@/models/ShopServiceModel';
import doc               from '@widesk-core/decorators/doc';
import model             from '@widesk-core/decorators/model';

export type DeliverableTransferTypeReference = 'no_regeneration' | 'claim';

@model.urnResource('deliverable_transfer_type')
@doc.path('/deliverable_transfer_types/{?id}')
export default class DeliverableTransferTypeModel extends ShopServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'label': string;
		'reference': DeliverableTransferTypeReference;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: DeliverableTransferTypeReference;
}
